import { z } from 'zod';

export const schema = z.object({
  notifyInvestorsViaEmail: z.boolean(),
  attachPdfNoticeToEmail: z.boolean(),
  automaticallySendReminders: z.boolean(),
});

export const strictSchema = schema;

export type FormValues = z.infer<typeof schema>;
